export type Filter = {
  name: string;
  placeholder: string;
  type: FilterTypes;
  value: string | null;
  filter?: (items: unknown, value: string) => unknown;
  options?: string[];
  regex?: RegExp;
};

export type FilterState = {
  name: string;
  placeholder: string;
  type?: FilterTypes;
  value: string;
};

export type KeyValueParams = {
  key: string;
  value: string;
}[];

export type InputChange = React.ChangeEvent<
  HTMLTextAreaElement | HTMLInputElement
>;

export enum FilterTypes {
  Date = "Date",
  Number = "Number",
  DateTime = "DateTime",
  String = "String",
  UppercaseString = "UppercaseString",
  Autocomplete = "Autocomplete",
  Regex = "Regex",
}
